var map = {
	"./0.png": 16,
	"./1.png": 17,
	"./10.png": 18,
	"./11.png": 19,
	"./12.png": 20,
	"./13.png": 21,
	"./14.png": 22,
	"./15.png": 23,
	"./2.png": 24,
	"./3.png": 25,
	"./4.png": 26,
	"./5.png": 27,
	"./6.png": 28,
	"./7.png": 29,
	"./8.png": 30,
	"./9.png": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;